import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  API: string;
  PDF?: string;
  API_IMAGENS?: string;
  API_IMAGENS_PRODUTOS?: string;
  API_BRANCH?: string;
  Layout?: number;
  NAME?: string;
  cypher?: boolean;
  prod?: boolean;
  abrePedidoEmGrupo?: boolean;
  gtagId?: string;
  registroLogin?: boolean;
  modoVisualizacaoPageProduto?: number;
  layoutMenu?: number;
  descontoPorItem?: number;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {

  private config!: AppConfig;

  constructor(private http: HttpClient) {}

  /**
   * Método chamado pelo APP_INITIALIZER
   * O Angular só sobe a aplicação depois que isso resolver
   */
  

  get apiUrl(): string {
    return this.config.API;
  }

  get appConfig(): AppConfig {
    return this.config;
  }
}
